import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

import { getUserDetails } from "../utils/userDetailsUtils";


const fetchTestCasesInSuite = async (testSuiteId, pageNumber) => {
    const user = getUserDetails();


    const response = await axios.get(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=gettestsuiteonpage&companyid=${user.companyid}&idtest_suite=${testSuiteId}&pnum=${pageNumber}`
    )
    return response.data;
}

const useFetchTestCasesInSuite = (testSuiteId, pageNumber) => {
    return useQuery({
        queryKey: ["testCasesInSuite", testSuiteId, pageNumber],
        queryFn: () => fetchTestCasesInSuite(testSuiteId, pageNumber),
        enabled: !!testSuiteId && !!pageNumber,
    })
}

export default useFetchTestCasesInSuite;